<template>
    <div class="button-third-party" @click="btnClick">
        <slot>
            <button class="btn btn-block" :data-tpa-type="tpaType">
                <div class="icon-wrapper">
                    <svgIcon icon-holder-class="icon-third-party" icon-id="icon-google-white" />
                </div>
                <span class="social-text">Continue with Google</span>
            </button>
        </slot>
    </div>
</template>

<script>
import queryString from 'query-string';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
    name: 'ButtonGoogle',
    components: {
        svgIcon,
    },
    props: {
        tpaType: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        oauthState: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            client_id: '399844538006-a1i92bv1j1g9bi4slijuot4j2lo7sj4b.apps.googleusercontent.com',
            scope: 'email',
            prompt: 'select_account',
            redirect_uri: `${window.location.origin}/account/login/callback/google`,
        };
    },
    methods: {
        btnClick() {
            this.$emit('click', 'Google');
            this.redirectMode();
        },
        redirectMode() {
            const params = new URLSearchParams();
            params.set('client_id', this.client_id);
            params.set('redirect_uri', this.redirect_uri);
            params.set('response_type', 'id_token');
            params.set('scope', this.scope);
            params.set('prompt', this.prompt);
            const clientCode = this.$uuid.v4();
            const return_url = this.$route.query.return_url;
            const state = {
                ...(this.oauthState || {}),
                ...(return_url ? { return_url } : {}),
                ...(this.$route.query.unified ? { unified: 'unified' } : {}),
            };
            // clientCode in state is only for launcher
            if (this.$store.state.isApplication) {
                state.clientCode = clientCode;
            }

            params.set('nonce', clientCode);
            params.set('state', encodeURIComponent(queryString.stringify(state)));

            const url = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;

            if (this.$store.state.isApplication) {
                this.$router.push({
                    name: 'login-tpa-callback-app',
                    params: { clientCode, socialProvider: 'Google', url },
                });
            } else {
                // normal browser redirect mode
                window.location = url;
            }
        },
    },
};
</script>

<style lang="less" scoped>
button {
    background-color: #4285f4;
    &:hover {
        background-color: #5a95f5;
    }
    &:focus {
        background-color: #c3c3c3;
    }
}
.button-third-party {
    margin: 0 0 10px;
    .btn {
        padding: 14px 0px;
    }
    position: relative;
    .icon-wrapper {
        display: inline-flex;
        padding-right: 16px;
        vertical-align: middle;
        .icon-third-party {
            width: 22px;
            height: 22px;
            margin-top: -1px;
        }
    }
    .social-text {
        color: #ffffff;
        font-size: 15px;
        vertical-align: middle;
    }
}
</style>
